import { Monitor, PenTool, UtensilsCrossed, FileText, Image as ImageIcon, MapPin, Share2, Megaphone } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const ICONS = { Monitor, PenTool, UtensilsCrossed, FileText, Image: ImageIcon, MapPin, Share2, Megaphone };

const Services = () => (
  <section id="tjanster" className="bg-navy2 py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>Våra tjänster</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Tjänster som stärker din digitala närvaro
        </h2>
        <p className="mt-4 text-base text-cream/60 sm:text-lg">
          Vi samlar webb, design och marknadsföring hos en partner – så slipper du hålla ihop det själv.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={(i % 4) * 0.07} className="h-full">
              <article
                data-testid={s.testId}
                className="group flex h-full flex-col rounded-2xl border border-white/10 bg-navy p-6 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-teal/70 hover:shadow-2xl hover:shadow-black/30"
              >
                <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-teal text-cream transition-colors duration-300 group-hover:bg-orange group-hover:text-navy">
                  <Icon size={22} strokeWidth={1.8} aria-hidden="true" />
                </div>
                <h3 className="font-display text-lg font-bold text-white">{s.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-cream/60">{s.description}</p>
                <p className="mt-4 font-display text-sm font-bold text-orange">{s.price}</p>
              </article>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-8 text-sm text-cream/40">Google- och Meta-annonskostnader betalas separat av kunden.</p>
      </Reveal>
    </div>
  </section>
);

export default Services;
